import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const FilterPanel = ({ onFilterChange, onExport }) => {
  const [filters, setFilters] = useState({
    segment: 'all',
    status: 'all',
    region: 'all',
    category: 'all',
    dateRange: 'last30days'
  });

  const segmentOptions = [
    { value: 'all', label: 'All Segments' },
    { value: 'enterprise', label: 'Enterprise' },
    { value: 'smb', label: 'SMB' },
    { value: 'startup', label: 'Startup' },
    { value: 'individual', label: 'Individual' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'suspended', label: 'Suspended' },
    { value: 'pending', label: 'Pending Verification' }
  ];

  const regionOptions = [
    { value: 'all', label: 'All Regions' },
    { value: 'jakarta', label: 'Jakarta' },
    { value: 'surabaya', label: 'Surabaya' },
    { value: 'bandung', label: 'Bandung' },
    { value: 'medan', label: 'Medan' },
    { value: 'bali', label: 'Bali' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'retail', label: 'Retail' },
    { value: 'fnb', label: 'Food & Beverage' },
    { value: 'ecommerce', label: 'E-commerce' },
    { value: 'services', label: 'Services' },
    { value: 'education', label: 'Education' }
  ];

  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'thismonth', label: 'This Month' },
    { value: 'lastmonth', label: 'Last Month' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    if (onFilterChange) {
      onFilterChange(newFilters);
    }
  };

  const handleReset = () => {
    const resetFilters = {
      segment: 'all',
      status: 'all',
      region: 'all',
      category: 'all',
      dateRange: 'last30days'
    };
    setFilters(resetFilters);
    if (onFilterChange) {
      onFilterChange(resetFilters);
    }
  };

  const activeFilterCount = Object.values(filters)?.filter(v => v !== 'all' && v !== 'last30days')?.length;

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-sm mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-muted-foreground" />
          <h3 className="text-base md:text-lg font-semibold text-foreground">Filters</h3>
          {activeFilterCount > 0 && (
            <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
              {activeFilterCount} active
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={handleReset}>
            Reset
          </Button>
          {onExport && (
            <Button variant="outline" size="sm" iconName="Download" onClick={onExport}>
              Export
            </Button>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        <Select
          label="Merchant Segment"
          options={segmentOptions}
          value={filters?.segment}
          onChange={(value) => handleFilterChange('segment', value)}
        />

        <Select
          label="Account Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
        />

        <Select
          label="Region"
          options={regionOptions}
          value={filters?.region}
          onChange={(value) => handleFilterChange('region', value)}
        />

        <Select
          label="Business Category"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => handleFilterChange('category', value)}
        />

        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => handleFilterChange('dateRange', value)}
        />
      </div>
      {activeFilterCount > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs text-muted-foreground">Active filters:</span>
            {Object.entries(filters)?.map(([key, value]) => {
              if (value === 'all' || (key === 'dateRange' && value === 'last30days')) return null;
              const option = 
                key === 'segment' ? segmentOptions?.find(o => o?.value === value) :
                key === 'status' ? statusOptions?.find(o => o?.value === value) :
                key === 'region' ? regionOptions?.find(o => o?.value === value) :
                key === 'category' ? categoryOptions?.find(o => o?.value === value) :
                dateRangeOptions?.find(o => o?.value === value);
              
              return (
                <span
                  key={key}
                  className="inline-flex items-center gap-1 px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full"
                >
                  {option?.label}
                  <button
                    onClick={() => handleFilterChange(key, key === 'dateRange' ? 'last30days' : 'all')}
                    className="hover:bg-primary/20 rounded-full p-0.5"
                  >
                    <Icon name="X" size={12} />
                  </button>
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;